import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import {
  Modal,
  Stack,
  Paper,
  Group,
  Button,
  Alert,
  Text,
  Loader,
  Code,
} from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";

import { MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS } from "../../../helpers/constants";
import {
  BOB_MODALS,
  MAX_BALANCE_SATOSHIS_TO_ALLOW_BOB_DELETE,
} from "../../helpers/constants";
import { Bob } from "../../stores/Bob";
import TwoFactorInput from "../details/twoFactorInput";

const DestroyWallet = observer(({ bob }: { bob: Bob }) => {
  const [isConfirmingDelete, setIsConfirmingDelete] = useState(false);
  const [twoFACode, setTwoFACode] = useState<string>("");
  useEffect(() => {
    if (bob.openModal === BOB_MODALS.DESTROY_WALLET) {
      bob.checkIfWeNeedToShowTwoFactorForm();
    }
  }, [bob.openModal]);

  const deleteWalletNow = () => {
    /* TODO: wire up real deletion */
    console.log("🔴 destroying wallet…");
    bob.sendDataAndDirectiveToRails("destroy-wallet-now", {
      twoFactorCode: twoFACode,
    });
    // bob.setOpenModal(null);
  };

  const balanceTooHigh =
    bob.safeBalanceInSatoshis + bob.inFlightSatoshis >
    MAX_BALANCE_SATOSHIS_TO_ALLOW_BOB_DELETE;

  return (
    <Modal
      opened={bob.openModal === BOB_MODALS.DESTROY_WALLET}
      onClose={() => bob.setOpenModal(null)}
      size={MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS}
      title="Delete This Vault"
    >
      <Paper withBorder shadow="md" p={24} radius="md">
        <Stack gap="md">
          <Text fw={500}>
            Current balance: {bob.safeBalanceInSatoshis.toLocaleString()}{" "}
            satoshis
          </Text>
          <Text>Lightning address:</Text>
          <Code block>{bob.lightningAddress} </Code>

          <Text>
            If you delete this vault, your Lightning address will stop working.
          </Text>

          {balanceTooHigh ? (
            <Alert color="red">
              You can’t delete this vault because it holds more than{" "}
              {MAX_BALANCE_SATOSHIS_TO_ALLOW_BOB_DELETE.toLocaleString()}{" "}
              satoshis. Please empty this vault first.
            </Alert>
          ) : !isConfirmingDelete ? (
            <Group gap="xs">
              <Button
                color="red"
                leftSection={<IconTrash size={14} />}
                onClick={() => setIsConfirmingDelete(true)}
              >
                Delete Vault
              </Button>
              <Button variant="default" onClick={() => bob.setOpenModal(null)}>
                Cancel
              </Button>
            </Group>
          ) : (
            <>
              <Alert color="red" title="Confirm Deletion">
                Are you absolutely sure? All data for this vault will be
                permanently removed. Your lightning address will stop working.
                {bob.safeBalanceInSatoshis > 5 && (
                  <>
                    {" "}
                    Your remaining balance of{" "}
                    {bob.safeBalanceInSatoshis.toLocaleString()} satoshis will
                    be gone forever!
                  </>
                )}
              </Alert>
              <TwoFactorInput
                visible={bob.workspace.accountRequiresTwoFactorFormForActions}
                code={twoFACode}
                onCodeChange={setTwoFACode}
              />
              <Group gap="xs">
                <Button
                  color="red"
                  leftSection={<IconTrash size={14} />}
                  onClick={deleteWalletNow}
                >
                  Yes, Delete
                </Button>
                <Button
                  variant="default"
                  onClick={() => setIsConfirmingDelete(false)}
                >
                  Cancel
                </Button>
              </Group>
            </>
          )}
          {bob.areWeWaitingOnRails && <Loader></Loader>}
        </Stack>
      </Paper>
    </Modal>
  );
});

export default DestroyWallet;
